var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "registrations-overview" }, [
    _c("table", { staticClass: "table table-hover" }, [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v(_vm._s(_vm.$t("support.table.updated")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("support.table.product")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("support.table.sitename")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("support.table.churchname")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("support.table.username")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("support.table.email")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("support.table.baselanguage")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("support.table.cta")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("support.table.status")))])
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm.isLoading
            ? _c("tr", [
                _c("td", { attrs: { colspan: "7" } }, [_c("spinner")], 1)
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.registrations, function(registration) {
            return _c(
              "tr",
              {
                on: {
                  click: function($event) {
                    return _vm.showDetails(registration.id)
                  }
                }
              },
              [
                _c("td", [
                  _vm._v(_vm._s(_vm._f("formatDate")(registration.last_update)))
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(registration.product))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(registration.siteName))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(registration.churchName))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("appellation." + registration.appellation)
                      ) +
                      " " +
                      _vm._s(registration.firstName) +
                      "\n                    " +
                      _vm._s(registration.lastName) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(registration.email))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(registration.baseLanguage))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(registration.cta))]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("setup-state", {
                      attrs: { setupStatus: registration.setupStatus }
                    })
                  ],
                  1
                )
              ]
            )
          }),
          _vm._v(" "),
          !_vm.isLoading && _vm.registrations.length === 0
            ? _c("tr", [
                _c("td", { attrs: { colspan: "7" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("support.registrationOverview.noDataFound"))
                  )
                ])
              ])
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0be951d8", { render: render, staticRenderFns: staticRenderFns })
  }
}